import { render, staticRenderFns } from "./AddItemIcon.vue?vue&type=template&id=3d3aa7e4&"
import script from "./AddItemIcon.vue?vue&type=script&lang=js&"
export * from "./AddItemIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports